module.exports = __webpack_public_path__ + "static/media/moby.536e049d.svg";